// extracted by mini-css-extract-plugin
export default {"recos":"i4-z","productCardOverride":"j4-z","rowHasBadge":"k4-z"};